import { render, staticRenderFns } from "./ShiftTeamTypeSelect.vue?vue&type=template&id=20822b99"
import script from "./ShiftTeamTypeSelect.vue?vue&type=script&lang=ts"
export * from "./ShiftTeamTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports